<template>
  <div
    :class="`fileSector${label ? '' : ' d-flex align-center'}`"
    v-if="items.length !== 0"
  >
    <p
      class="d-flex align-center mb-0"
      v-for="item in items"
      :key="item"
    >
      <span
        :style="`background:${getItem(item).color};height:${size}px;width:${size}px;display:flex;`"
        :class="{ 'mr-1': spacing }"
      />
      <span class="ml-1 mb-0" v-if="label">
        {{ getItem(item)[`name_${$i18n.locale.split('-')[0]}`] }}
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'iconSectors',
  data() {
    return {
      datas: [],
      dico: [
        "AL-ELEVBOVI", "AL-ELEVPORC", "AL-ELEVAVIC", "AL-ELEVCUNI",
        "GL-ESPAVERT", "GL-GRANCULT", "GL-HORTIPEP", "GL-MARAICHA",
        "WL-POTABILI", "WL-TREAUPROC", "WL-TREAUUSEE",
        "IL-INDUATEX", "IL-INDUTRAN", "IL-INDUMETA", "IL-INDUGRAP",
        "FL-HYGIAGRO", "FL-HYGICOLLE", "FL-HYGIHOSP", "FL-NETTINDUS",
      ],
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 30
    },
    label: {
      type: Boolean,
      default: false
    },
    spacing: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.sortItems()
  },
  destroy () {
    this.datas = []
    this.items = []
  },
  methods: {
    sortItems () {
      if (this.items.length !== 0) {
        this.datas = this.items.sort((a, b) => this.dico.indexOf(a) - this.dico.indexOf(b))
      }
    },

    getItem (value) {
      const items = this.$store.getters["home/termsType"]('sectors')
      return items.filter(f => f.key === value)[0]
    },
  }
}
</script>
